import { InputText, Select, Checkbox, formatDate } from '@ui/src';
import { NatureOfControlEnum } from '../../../hoc/new-application/types';
import {
  AccessRight,
  SignatureType,
  NewCofProps,
} from '../../../hoc/common/types';
import { SelectCompanyOfficialTypes } from '../types';

import cn from './overview.module.css';

const SelectCompanyOfficialForm = ({
  customer,
  havingControl,
  setFormValues,
  percentageError,
  customerId,
  errors,
}: SelectCompanyOfficialTypes) => (
  <>
    <div className={cn.companyOfficialValueWrapper}>
      <InputText
        name="dob"
        value={customer?.dob ? formatDate(customer?.dob) : ''}
        title="Date of Birth"
        placeholder="Birth date"
        error={errors?.dob?.message as string}
        disabled
      />
    </div>
    <div className={cn.companyOfficialValueWrapper}>
      <InputText
        name="position"
        value={customer?.position}
        title="Position"
        placeholder="Enter position"
        onChange={(e) =>
          setFormValues({
            ...customer,
            position: e.target.value,
          } as NewCofProps)
        }
        error={errors?.position?.message as string}
        disabled={!customerId}
      />
    </div>
    <div className={cn.companyOfficialValueWrapper}>
      <Checkbox
        type="checkbox"
        name="havingControl"
        checked={customer?.havingControl}
        title="Having a control in company"
        onChange={(e) =>
          setFormValues({
            ...customer,
            havingControl: e.target.checked,
          } as NewCofProps)
        }
        disabled={!customerId}
      />
    </div>
    {havingControl && (
      <div
        className={`${cn.companyOfficialValueWrapper} ${cn.companyOfficialValueWrapperFlex}`}
      >
        <div className={cn.inputFlex}>
          <InputText
            name="percentage"
            value={customer?.percentage}
            title="Percentage of control"
            placeholder="Enter Percentage of control"
            onChange={(e) =>
              setFormValues({
                ...customer,
                percentage: e.target.value,
              } as NewCofProps)
            }
            error={(errors?.percentage?.message as string) || percentageError}
            disabled={!customerId}
          />
        </div>
        <div className={cn.inputFlex}>
          <Select
            list={[
              {
                name: 'Direct Control',
                value: NatureOfControlEnum.DIRECT_CONTROL,
              },
              {
                name: 'Indirect Control',
                value: NatureOfControlEnum.INDIRECT_CONTROL,
              },
            ]}
            name="natureOfControl"
            selectWrapperClassName={cn.companyOfficialSelect}
            value={customer?.natureOfControl}
            title="Nature of control"
            placeholder="Select Nature of Control"
            error={errors?.natureOfControl?.message as string}
            onChange={(e) =>
              setFormValues({
                ...customer,
                natureOfControl: e.target.value,
              } as NewCofProps)
            }
          />
        </div>
      </div>
    )}
    <div className={cn.companyOfficialValueWrapper}>
      <Select
        list={[
          {
            name: 'None',
            value: SignatureType.NONE,
          },
          {
            name: 'Single',
            value: SignatureType.SINGLE,
          },
        ]}
        name="signatureType"
        value={customer?.signatureType}
        placeholder="Select signature type"
        title="Signature Type"
        error={errors?.signatureType?.message as string}
        onChange={(e) =>
          setFormValues({
            ...customer,
            signatureType: e.target.value,
          } as NewCofProps)
        }
        disabled={!customerId}
        fullWidth
      />
    </div>
    <div className={cn.companyOfficialValueWrapper}>
      <Select
        list={[
          {
            name: 'Company Official',
            value: 'COMPANY_OFFICIAL',
          },
          {
            name: 'Main representative',
            value: 'MAIN_REPRESENTATIVE',
          },
        ]}
        onChange={(e) =>
          setFormValues({
            ...customer,
            companyOfficialType: e.target.value,
          } as NewCofProps)
        }
        name="companyOfficialType"
        error={errors?.companyOfficialType?.message as string}
        value={customer?.companyOfficialType || 'COMPANY_OFFICIAL'}
        title="Company Official Type"
        fullWidth
      />
    </div>
    <div className={cn.companyOfficialValueWrapper}>
      <Select
        list={[
          {
            name: 'None',
            value: AccessRight.NONE,
          },
          {
            name: 'Viewer',
            value: AccessRight.VIEWER,
          },
        ]}
        name="accessRight"
        value={customer?.accessRight || AccessRight.VIEWER}
        onChange={(e) =>
          setFormValues({
            ...customer,
            accessRight: e.target.value,
          } as NewCofProps)
        }
        title="Access Right"
        fullWidth
      />
    </div>
  </>
);

export default SelectCompanyOfficialForm;
